import { Component, OnInit, AfterViewInit, Inject, OnDestroy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatSliderModule, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';        
import { ISubscription } from "rxjs/Subscription";
import { TopnavService } from '../header/topnav/topnav.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { Http } from '@angular/http';
import * as $ from 'jquery';
// import { tileLayer, latLng, circle, polygon, marker, icon, Layer } from 'leaflet';

import * as L from 'leaflet';
import 'leaflet';
import 'leaflet.markercluster';
import 'leaflet.markercluster.layersupport';
import 'hammerjs';

// const L = window['L'];
import { SharedService } from '../common/shared.service';
import { PortalService } from '../services/portal.service';
import { ToastrService } from 'ngx-toastr';
import { NavService } from '../header/nav/nav.service';
//import { equalParamsAndUrlSegments } from '@angular/router/src/router_state';
//import { getRectCenter } from 'fullcalendar';

export interface DialogData {
  recInfo;
  typeData;
  phone;
  fax;
  stateName;
  workingH;
  fullAdd;
}

/**
 * Author: Noraini A.Ghani
 * 
 * Date Created: January 14th 2020
 * 
 * Description: Component class for MyDestinasi - /mydestinasi
 **/
@Component({
  selector: 'gosg-mydestinasi',
  templateUrl: './mydestinasi.component.html',
  styleUrls: ['./mydestinasi.component.css']
})
export class MydestinasiComponent implements OnInit, AfterViewInit, OnDestroy {
  
  public myflag: any;
  lang: any;
  langID: any;
  complete: boolean;
  validNS: boolean;
  completeLatLong = true;  
  oriRecPlace = [];
  recordPlace = [];
  recordPlaceTbl = [];
  rangeDistance = [200, 50000];

  showNoData = false;
  loading = false;
  
  private typingTimer: any;
  private doneTypingInterval:number = 1200;

  public listState: any;
  public listCategory = [{id:1, text_ms:"Negeri", text_en:"State"},
                         {id:2, text_ms:"Lokasi Pengguna", text_en:"User Location"}];  
  public listLokasi = [{id: 1, text_en: "Your Location", text_ms: "Lokasi Anda"}, {id: 2, text_en: "Selected Location", text_ms: "Lokasi yang dipilih"}];

  public originalRecord = 0;
  public noOfR: any;
  public pageNo = 1;
  public totalPageNo = 1;
  public limit = 15;
  public showDetails = false;

  mapForm: FormGroup;
  public jCarian: FormControl;
  public allState: FormControl;
  public latitude: FormControl;
  public longitude: FormControl;   
  public distance: FormControl;
  public subKat: FormControl; //checkbox
  public subKat2: FormControl; //checkbox
  public keyword: FormControl;
  
  selectedState: any;
  allTree = []; //used for combination tree
  listName: any;
  listMainTree: any;
  openFlag = true;
  sameCategoryCodeLvl1 = [];
  selectedCat = [];
  currCategory;
  objCategory = {};
  objCatByAgency = {};
  objIcon = {};
  mapWide = false;
  minDisplay: any;
  maxDisplay: any;
  currDistance: any;
  // currDistance = this.sharedService.rangeDistance[0]/1000;
  noTabAgency = [];
  currTabRec = [];
  currTB: any;

  geolokasiT = '';
  geolokasi1 = '';
  geolokasi2 = '';
  geolokasi3 = '';

  mymap;
  markerGroup;
  mcgLayerSupportGroup;
  markerUser;
  circleUser;
  circleRad;
  popup = L.popup();
  defaultIcon = L.icon({
    iconUrl: 'assets/marker/marker-icon-yellow.png',
    shadowUrl: 'assets/marker-shadow.png',
    iconSize: [15, 24], // size of the icon 25, 41
    shadowSize: [20, 21], // size of the shadow 40, 41
    iconAnchor: [15/2, 24], // point of the icon which will correspond to marker's location
    shadowAnchor: [15/2, 24],  // the same for the shadow
    popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
  });

  flagErrorConnect: any;

  private subscriptionFontType: ISubscription;
  public fontType: string = 'Arial';
  private subscriptionFontSize: ISubscription;
  private subscriptionListPoint: ISubscription;
  private subscriptionMainTree: ISubscription;
  private subscriptionLoopTree2: ISubscription;
  private subscriptionExpandTree: ISubscription;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };
  private mStyle: string; 

  constructor(
    private sharedService: SharedService,
    private portalservice: PortalService,
    private activatedRoute: ActivatedRoute,
    private navService: NavService,
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private http: Http,
    private toastr: ToastrService,
    @Inject(APP_CONFIG) private config: AppConfig,
    public dialog: MatDialog,
    private topnavservice: TopnavService,
    ) {

    // this.navService.digitalTop = true;

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      const myLang = translate.currentLang;

      let a = this.router.url.split('/')[1];
      console.log("a: ",a);

      if (myLang == 'en') {
          translate.get('HOME').subscribe((res: any) => {
              this.lang = 'en';
              this.langID = 1;
          });
      }

      if (myLang == 'ms') {
          translate.get('HOME').subscribe((res: any) => {
              this.lang = 'ms';
              this.langID = 2;
          });
      }

      if(this.topnavservice.flagLangAppMngmnt  && a == "mydestinasi"){
        this.allTree = [];
        this.getMainTree(this.langID);
        this.geoLokasi();
        this.resetMethod();
      }      

      setTimeout(()=>{
        this.translate.get('pageTitle.home').subscribe((title:string) => {
          title = this.translate.instant('mydestinasi.search.topTitle');
          this.sharedService.setTitle(title);
        }); 
      },500); 
    });    

    this.activatedRoute.queryParams.subscribe(params => {
      let lng = params['language'];
      if (lng && lng.toLowerCase() == 'my') {
        this.myflag = {language:"my"};
        this.translate.setDefaultLang('ms');
        this.translate.use('ms');
      } else {
        this.myflag = null;
      } 
    });
    
    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      this.fontSize = data;
      if (localStorage.getItem('customFontType')) {
        this.fontType = localStorage.getItem('customFontType');
      }
      this.mStyle = 'style="margin: 0px; font-family:' + this.fontType + '; font-size:' + this.fontSize.sizeS + ';"';
    });

    this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data)=>{
      this.fontType = data;
      this.mStyle = 'style="margin: 0px; font-family:' + this.fontType + '; font-size:' + this.fontSize.sizeS + ';"';
    });
  }

  ngOnDestroy() {
    this.subscriptionFontSize.unsubscribe();
    this.subscriptionFontType.unsubscribe();
    if(this.subscriptionListPoint){
     this.subscriptionListPoint.unsubscribe();    
    }
    if(this.subscriptionMainTree){
      this.subscriptionMainTree.unsubscribe();
    }
    if(this.subscriptionLoopTree2){
      this.subscriptionLoopTree2.unsubscribe();
    }
    if(this.subscriptionExpandTree){
      this.subscriptionExpandTree.unsubscribe();
    }
  }

  ngOnInit() {

    this.geoLokasi();

    if(!this.langID){
      if (localStorage.getItem('langID')) {
        this.langID = localStorage.getItem('langID');
      } else {
        this.langID = 1;    
      }
    }

    $(window).scrollTop(0);

    this.jCarian = new FormControl();
    this.allState = new FormControl();    
    this.latitude = new FormControl();
    this.longitude = new FormControl();
    this.distance = new FormControl();
    this.subKat = new FormControl();
    this.subKat2 = new FormControl();
    this.keyword = new FormControl();
    
    this.mapForm = new FormGroup({
      jCarian: this.jCarian,
      allState: this.allState,

      latitude : this.latitude,
      longitude : this.longitude,
      distance : this.distance,
      subKat: this.subKat,
      subKat2: this.subKat2,
      keyword: this.keyword
    });

    this.mapForm.get('jCarian').setValue(1);
    this.mapForm.get('latitude').disable();
    this.mapForm.get('longitude').disable();

    // defaut disable checkbox
    this.mapForm.get('subKat').disable();
    this.mapForm.get('subKat2').disable();

    this.getState();
    this.getDefaultMap();    
    this.getMainTree(this.langID);

    document.getElementById("bttnHam").style.display = "none";
    this.openNavMap();
  }

  ngAfterViewInit() {
 
    // Get Title and Sent to GA
    this.translate.get('pageTitle.home').subscribe((title:string) => {
      title = this.translate.instant('mydestinasi.search.topTitle');
      this.sharedService.setTitleAndGtag(title);
    });
    
    this.sharedService.loadFontSizeData();
    this.sharedService.loadFontTypeData();
  }

  geoLokasi(){
    if(this.langID == 1){
      this.geolokasi1 = '(get directions using';
      this.geolokasi2 = 'or open the'; 
      this.geolokasi3 = ' app)</p>';
      this.geolokasiT = 'Geolocation';
    }
    else{
      this.geolokasi1 = '(dapatkan arah menggunakan';
      this.geolokasi2 = 'atau buka aplikasi';
      this.geolokasi3 = '';
      this.geolokasiT = 'Geolokasi';
    }
  }

  changeLState(state){
    this.selectedState = state;
    console.log("Negeri yg dipilih: ",state);
    this.mapForm.get('subKat').enable();
    this.mapForm.get('subKat2').enable();
    this.mymap.closePopup();
    this.setMapByScreen();

    // if(this.markerGroup){
    //   this.mymap.removeLayer(this.markerGroup); 
    //   this.mymap.closePopup();
    // } 
    if(this.markerUser){
      this.mymap.removeLayer(this.markerUser);
      this.mymap.removeLayer(this.circleUser);
    }

    // this.setMapByScreen();
    // this.mapForm.get('subKat').reset();
    // this.mapForm.get('subKat2').reset();
    // this.mapForm.get('keyword').reset();
    // this.selectedCat = [];
    // this.sameCategoryCodeLvl1 = [];
    // this.recordPlaceTbl = [];
    // this.recordPlace = [];
    // this.objCategory = {};
    // this.objCatByAgency = {};
    // this.objIcon = {};

    // this.pageNo = 1;
    // this.totalPageNo = 1;
    // this.limit = 15;
    // this.showDetails = false;

    if(this.mapForm.controls.jCarian.value == 2){//reset latlong complete.
      this.completeLatLong = false;
    }

    // ***bile dah click category
    if(Object.keys(this.objCatByAgency).length > 0){
      this.oriRecPlace = [];
      this.searchMultipleCat(0, Object.keys(this.objCatByAgency).length);
    }
    
    this.checkReqValues(); // check to disable search btn
  }

  currZoom(cd){
    let valZ;

    if(cd <= 5){
      valZ = 14;
    }
    else if(cd > 5 && cd <= 20){
      valZ = 12;
    }
    else if(cd > 20 && cd <= 30){
      valZ = 11;
    }
    else if(cd > 30 && cd <= 50){
      valZ = 10;
    }

    return valZ;
  }

  changeRad(val){

    let a = val;
    this.currDistance = a / 1000;   
    var mapForm = this.mapForm;
    let lat = mapForm.get('latitude').value;
    let long = mapForm.get('longitude').value;    

    console.log("Distance : ",a, " Lat : ",lat, " Long : ", long, " Curr Distance : ", this.currDistance);
        
    // this.mymap.flyTo([lat, long], this.currZoom(this.currDistance));
    
    if(this.circleRad){
      this.mymap.removeLayer(this.circleRad);
    }

    if(lat && long){
      this.circleRad = L.circle([lat, long], a, {
        weight: 1,
        color: '#61FF33',
        fillColor: '#61FF33',
        fillOpacity: 0.2
      });

      this.mymap.addLayer(this.circleRad);
    }

    // ***bile dah click category
    if(Object.keys(this.objCatByAgency).length > 0){
      this.oriRecPlace = [];


      let callApi = 'yes';

      if(this.mapForm.get("jCarian").value == 2 && 
        !this.mapForm.get('latitude').value && !this.mapForm.get('longitude').value){
        callApi = 'no';
      }

      if(callApi == "yes"){
        this.searchMultipleCat(0, Object.keys(this.objCatByAgency).length);
      }else{
        console.log("BY RADIUS MULTIPLE");
      }
    }
    
    let kl = this.mymap.getCenter();
  }
 
  changeJCarian(type, flagReset?){

    console.log("JENIS CARIAN: ");

    if(flagReset){      
      this.resetSearch();
    }
    this.originalRecord = 0;
    this.completeLatLong = false;    

    if(type == 2){
      this.mapForm.get('subKat').enable();
      this.mapForm.get('subKat2').enable();

      this.mapForm.get('distance').setValue(this.rangeDistance[0]);
      this.minDisplay = this.rangeDistance[0] / 1000;
      this.maxDisplay = this.rangeDistance[1] / 1000;    

      let main = this;
      let mymap = this.mymap;
      let mapForm = this.mapForm;
      let completeLatLong = this.completeLatLong;

      let defaultIcon = L.icon({
        iconUrl: 'assets/marker/marker-icon-yellow.png',
        shadowUrl: 'assets/marker-shadow.png',
        iconSize: [15, 24], // size of the icon 25, 41
        shadowSize: [20, 21], // size of the shadow 40, 41
        iconAnchor: [15/2, 24], // point of the icon which will correspond to marker's location
        shadowAnchor: [15/2, 24],  // the same for the shadow
        popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
      });

      console.log("111111111111111 LUF()");
      this.locateUser();  
      
      this.mymap.on('click', function(e) {
        
        mymap.flyTo([e.latlng.lat,e.latlng.lng]);
        // mymap.flyTo([e.latlng.lat,e.latlng.lng], 15);
        
        // let y = document.getElementsByClassName('leaflet-map-pane');    
        // $(y).css('transform','translate3d(0px, 0px, 0px)');
        // $(y).css('transform','translate3d(-150px, 0px, 0px)');

        if(main.markerUser){
          mymap.removeLayer(main.markerUser);
          mymap.removeLayer(main.circleUser);
        }

        if(main.circleRad){
          mymap.removeLayer(main.circleRad);
        }

        // main.markerUser = L.marker([e.latlng.lat, e.latlng.lng], { icon: defaultIcon }).bindPopup((this.langID==1)?'Your selected location':'Lokasi yang dipilih');
        main.markerUser = L.marker([e.latlng.lat, e.latlng.lng], { icon: defaultIcon }).bindPopup(e.latlng.lat+","+e.latlng.lng);
        main.circleUser = L.circle([e.latlng.lat, e.latlng.lng], 100, {
            weight: 1,
            color: 'red',
            fillColor: 'red',
            fillOpacity: 0.5
        });  
        mymap.addLayer(main.markerUser);
        mymap.addLayer(main.circleUser);

        if(mapForm.get('distance').value){            
          
          let a = mapForm.get('distance').value
          main.circleRad = L.circle([e.latlng.lat, e.latlng.lng], a, {
              weight: 1,
              color: '#61FF33',
              fillColor: '#61FF33',
              fillOpacity: 0.2
          });            
          mymap.addLayer(main.circleRad);
        }

        mapForm.get('latitude').setValue(e.latlng.lat);
        mapForm.get('longitude').setValue(e.latlng.lng);
        
        main.completeLatLong = true;

        // ***bile dah click category
        if(Object.keys(main.objCatByAgency).length > 0){
          main.oriRecPlace = [];
          main.searchMultipleCat(0, Object.keys(main.objCatByAgency).length);
        }
      });
      
    }else{
      this.mapForm.get('subKat').disable();
      this.mapForm.get('subKat2').disable();
      this.completeLatLong = true;
      this.mymap.off('click');      
    }
  }

  errState(){
    if(!this.mapForm.controls.allState.value && this.mapForm.get('jCarian').value == 1){
      this.sharedService.showError(this.translate.instant('mydestinasi.search.form.negeri_error'), '');
    }
  }

  errAgencyConnect(){    
    
    if(this.langID==1){
      this.sharedService.showError('Server could not be connected.', '');
    }else{
      this.sharedService.showError('Pelayan tidak dapat dihubungkan.', '');
    }
  }

  isChecked(e, dSelf, dParent){    

    this.mymap.closePopup();
    this.setMapByScreen();
    this.currCategory = e.source.value;
    let paramUrl = ''; 
    let api, p;
    
    if(this.mapForm.get('jCarian').value == 1){
      paramUrl = 'getPlaceInfo';

      p = { "state" : parseInt(this.mapForm.get('allState').value),
            "category": [this.currCategory],
            "keyword": null
          };
    }   
    else if(this.mapForm.get('jCarian').value == 2){
      paramUrl = 'getPlaceInfoByRadius';

      p = { "lat" : this.mapForm.get('latitude').value,
            "long" : this.mapForm.get('longitude').value,
            "distance" : this.mapForm.get('distance').value,
            "category": [this.currCategory],
            "keyword": null
          };
    }  

    api= dParent.value.sourceUrl+paramUrl;
    console.log("dParent in isChecked : ", dParent);
        
    if(e.checked){ // ***select category      
      
      this.selectedCat.push(e.source.value);
      this.sameCategoryCodeLvl1.push(dParent.value.code);
      this.objIcon[e.source.value]  = {"icon": dSelf.value.icon, 
                                      "label": dSelf.value.label, 
                                   "category": e.source.value};

      if(!this.objCatByAgency[dParent.value.code]){
        this.objCatByAgency[dParent.value.code] = {"url": dParent.value.sourceUrl, 
                                                  "icon": dSelf.value.icon, 
                                                 "label": dSelf.value.label, 
                                                "parent": dParent.value.code, 
                                                  "data": []};
      }

      console.log(this.objIcon);
     
      let callApi = 'yes';

      if(this.mapForm.get("jCarian").value == 2 && 
        !this.mapForm.get('latitude').value && !this.mapForm.get('longitude').value){
        callApi = 'no';
      }

      if(callApi == "yes"){
        this.getPlaceInfoAll(false, this.limit, api, p, dParent.value.code);
      }else{
        console.log("BY RADIUS");
      }
      
    }
    else{ // ***deselect category
      
      let index = this.selectedCat.indexOf(e.source.value);
      this.selectedCat.splice(index, 1);
      let ind = this.sameCategoryCodeLvl1.indexOf(dParent.value.code);
      this.sameCategoryCodeLvl1.splice(ind, 1);     
      
      delete this.objIcon[e.source.value];

      // ***check if there is same parent or not; 
      // ***parent > 1 = do not delete the peroperty; 
      // ***parent = 0 delete property
      let parent = this.sameCategoryCodeLvl1.filter(function(value){
        return value === dParent.value.code;
      }).length; 

      // *** parent = 0 delete property
      if(parent == 0){
        delete this.objCatByAgency[dParent.value.code];
      }

      this.removeCluster(dParent.value.code, parent);     
    }
   
    this.noTabAgency = Object.keys(this.objCatByAgency);
    console.log("Ini no of TAB AGENCY based on object : ",this.noTabAgency);
    console.log("****COUNT PARENT CATEGORY **** : ",this.countUnique(this.sameCategoryCodeLvl1));

    $(window).scrollTop(85);
  }

  countUnique(iterable) {
    return new Set(iterable).size;
  }
  
  openAnswer(flag, lvl, dParent, i, u) {
 
    if(lvl == 1){
      if(flag == true){
        this.openFlag = true; 
      }else{
        this.openFlag = false;  
      }
    }

    else if(lvl == 2){
      this.getExpandTree(dParent.value.code, dParent.value.sourceUrl, i, flag)

      // this.listMainTree[i].value['openFlag2nd'] = flag;
      // if(flag){
      //   let y = document.getElementsByClassName(i);  
      //   $(y).css('display','block');
      //   console.log(y);
      // }
      // else{
      //   let y = document.getElementsByClassName(i);  
      //   $(y).css('display','none');
      // }
    }

    else if(lvl == 3){
      console.log("iiiii: ", i, "uuuuuu: ", u);
      console.log("Level: ", lvl)
      console.log("Code: ",dParent.text)
      if(flag){
        let x = document.getElementsByClassName("subC2"+u);  
        $(x).css('display','block');      
        $("span."+i+u).hide();
        $("span."+u+"_"+i).show();
      }
      else{
        let x = document.getElementsByClassName("subC2"+u);  
        $(x).css('display','none');
        $("span."+i+u).show();
        $("span."+u+"_"+i).hide();
      }
    }
  }

  openNavMap() {
    
    document.getElementById("bttnHam").style.display = "none";
    document.getElementById("mySidenavDest").style.display = "block";
    document.getElementById("mySidenavDest").style.width = "300px";
    // // start Sidenav push (off-canvas)
    // document.getElementById("mainDest").style.marginLeft = "300px";
    // document.getElementById("mainDest").style.width = "-webkit-calc(100% - 300px)";
    // // end Sidenav push (off-canvas)

    // start Sidenav overlay
    document.getElementById("mainDest").style.marginLeft= "0";
    document.getElementById("mainDest").style.width = "100%";
    // end Sidenav overlay

    this.mapWide = false;
  }
  
  closeNavMap() {
    
    document.getElementById("bttnHam").style.display = "block";
    document.getElementById("mySidenavDest").style.display = "none";    
    document.getElementById("mySidenavDest").style.width = "0";
    document.getElementById("mainDest").style.marginLeft= "0";
    document.getElementById("mainDest").style.width = "100%";

    this.mapWide = true;
    // this.setMapByScreen();
  }

  displayPopup(lat, long, nameS, addressS, phone, postcode, state, distance?){
    let display = '';
    let mStyle = this.mStyle;
    let showDistance = "";

    let dataLat = this.mapForm.get('latitude').value;
    let dataLong = this.mapForm.get('longitude').value;
    let getLL = '';

    let sName = '';    
    let a = state;
    let stateName = this.listState.filter(function(value){
      if(a == value.stateCode){ //Temporary only. BE need to send id_state from MIMOS not from agency
        return value.stateName;
      }
    });

    let distancekm = 0;

    if(stateName.length > 0){
      sName = stateName[0].stateName;
    }

    let address = '';
    address += (addressS) ? addressS+',': '';
    let pCode = '';
    pCode += (postcode) ? postcode: '';

    this.geoLokasi();

    if(dataLat){
      getLL = '&origin='+dataLat+'/'+dataLong;
    }

    if(phone == null){
      phone = 'Tiada';
    }

    if(distance){
      distancekm = parseFloat((distance/1000).toFixed(1));
    showDistance =`
      <div class='row'>
        <div class='col-xs-2' style='padding-right: 0px;'>
          <i class='fa fa-location-arrow' style='font-size: 1.2em; margin-top: 0px;'></i>
        </div>
        <div class='col-xs-10' style='padding-left: 0px;'>
          <p style='margin-top: 0px; margin-bottom: 0px;'>${distancekm} km</p>
        </div>
      </div>`
    }

    display = `
      <div class='row'>
        <div class='col-xs-12'>
          <h5 class="font-size-s" ${mStyle}>${nameS}<h5>
        </div>
      </div>
      <div class='row'>
        <div class='col-xs-2' style='padding-right: 0px;'>
          <i class='fa fa-home' style='font-size: 1.2em; margin-top: 0px;'></i>
        </div>
        <div class='col-xs-10' style='padding-left: 0px;'>
          <p ${mStyle}>${address} ${pCode} ${sName}</p>
        </div>
      </div>
      <div class='row'>
        <div class='col-xs-2' style='padding-right: 0px;'>
          <i class='fa fa-phone' style='font-size: 1.2em; margin-top: 0px;'></i>
        </div>
        <div class='col-xs-10' style='padding-left: 0px;'>
          <p ${mStyle}>${phone}</p>
        </div>
      </div>
      <div class='row'>
        <div class='col-xs-2' style='padding-right: 0px;'>
          <i class='fa fa-map-marker' style='font-size: 1.2em; margin-top: 0px;'></i>
        </div>
        <div class='col-xs-10' style='padding-left: 0px;'>
          <p ${mStyle}>${this.geolokasiT}: ${lat},${long} 
          ${this.geolokasi1} <a href='https://www.google.com/maps/dir/?api=1${getLL}&destination=${lat},${long}&hl=ms'
          target='_blank'>Google Maps</a> 
          ${this.geolokasi2} <a href='https://hub.grab.com/ul/' target='_blank'>Grab</a>${this.geolokasi3}</p>
        </div>
      </div>
      ${showDistance}`;
    return display;
  }

  // open popup on map
  goTo(lat, long, nameS, addressS, phone, postcode, state, distance?) {

    let distancekm = 0;
    this.mymap.closePopup(); 

    // if(this.popup){
    //   this.mymap.removeLayer(this.popup);   
    // }

    this.geoLokasi();
    $(window).scrollTop(85);
    // document.getElementById("dirmap").scrollIntoView();
    let mStyle = this.mStyle;
    let dataLat = this.mapForm.get('latitude').value;
    let dataLong = this.mapForm.get('longitude').value;
    let getLL = '';

    let sName = '';
    let a = state;
    let stateName = this.listState.filter(function(value){
      if(a == value.stateCode){ //Temporary only. BE need to send id_state from MIMOS not from agency
        return value.stateName;
      }
    });

    if(stateName.length > 0){
      sName = stateName[0].stateName;
    }

    if(dataLat){
      getLL = '&origin='+dataLat+'/'+dataLong;
    }

    // if (lat && long) {
    if (lat != '-' || lat != null) {

      let showDistance = "";

      let address = '';
      address += (addressS) ? addressS+',': '';
      let pCode = '';
      pCode += (postcode) ? postcode: '';

      if(phone == null){
        phone = 'Tiada';
      }

      if(distance){

        distancekm = parseFloat((distance/1000).toFixed(1));
        showDistance =`
        <div class='row'>
          <div class='col-xs-2' style='padding-right: 0px;'>
            <i class='fa fa-location-arrow' style='font-size: 1.2em; margin-top: 0px;'></i>
          </div>
          <div class='col-xs-10' style='padding-left: 0px;'>
            <p ${mStyle}>${distancekm} km</p>
          </div>
        </div>`
      }

      // this.mymap.setZoom(20,{
      //   "animate": true,
      //   "pan": {
      //     "duration": 1
      //   }
      // });
      // this.mymap.panTo([lat, long], { animate: true, easeLinearity: .20, duration: 2 });   
      //this.mymap.flyTo([dLat, dLong], 13);
      //this.mymap.setView([lat, long], 24); 

      
      // if(lat && long){
      if(parseFloat(this.malformedDataHandler(lat))!== 0 && parseFloat(this.malformedDataHandler(long)) !== 0){
        
        this.mymap.flyTo([lat, long], 16);                
       
        this.popup = L.popup()
          .setLatLng([lat, long])
          .setContent(`
          <div class='row'>
            <div class='col-xs-12'>
              <h5 ${mStyle} >${nameS}<h5>
            </div>
          </div>
          <div class='row'>
            <div class='col-xs-2' style='padding-right: 0px;'>
              <i class='fa fa-home' style='font-size: 1.2em; margin-top: 0px;'></i>
            </div>
            <div class='col-xs-10' style='padding-left: 0px;'>
              <p ${mStyle}>${address} ${pCode} ${sName}</p>
            </div>
          </div>
          <div class='row'>
            <div class='col-xs-2' style='padding-right: 0px;'>
              <i class='fa fa-phone' style='font-size: 1.2em; margin-top: 0:'></i>
            </div>
            <div class='col-xs-10' style='padding-left: 0px;'>
              <p ${mStyle}>${phone}</p>
            </div>
          </div>
          <div class='row'>
            <div class='col-xs-2' style='padding-right: 0px;'>
              <i class='fa fa-map-marker' style='font-size: 1.2em; margin-top: 0px;'></i>
            </div>
            <div class='col-xs-10' style='padding-left: 0px;'>
              <p ${mStyle}>${this.geolokasiT}: ${lat},${long} 
              ${this.geolokasi1} <a href='https://www.google.com/maps/dir/?api=1${getLL}&destination=${lat},${long}&hl=ms'
              target='_blank'>Google Maps</a> 
              ${this.geolokasi2} <a href='https://hub.grab.com/ul/' target='_blank'>Grab</a>${this.geolokasi3}</p>
            </div>
          </div>
          ${showDistance}
          `).openOn(this.mymap);


          // var popup = this.mymap.getPopup(); // returns marker._popup

          // console.log("Popup Buka: ", popup);
          // L.DomEvent.addListener(this.mymap, 'click', function(event){
          //   console.log("Apa");
          //   // do stuff
          // }, this.mymap);

          // L.popup()
          // .setLatLng([lat, long])
          // .setContent('').openOn(map);

          // this.mymap.addLayer(this.popup).on('popupopen', function(e) {

          //   console.log("EEEE: ",e);
          //   var px = this.popup.project(e.target._popup._latlng);
          //   console.log("PX: ",px);
          //   px.y -= e.target._popup._container.clientHeight/2;        
          //   this.mymap.panTo(this.popup.unproject(px),{animate: true});
          // });


          // this.mymap.flyTo([lat, long], 16);   
          // this.mymap.on('popupopen', function(e) {
          //   var px = this.mymap.project(e.target._popup._latlng);
          //   console.log("PX: ",px);
          //   px.y -= e.target._popup._container.clientHeight/2;        
          //   this.mymap.panTo(this.mymap.unproject(px),{animate: true});
          // });
      }
      else{ //tiada lat atau long set default map view
        this.setMapByScreen();
      }

    } else{}
  }
  
  getState() {
    this.loading = true;
    return this.sharedService.getStateData().subscribe(
    resStateData => {
      this.listState = resStateData;

      this.loading = false;
    },
    Error => {
      this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
      this.loading = false;
    });
  }

  getMainTree(lang){

    this.loading = true;    

    this.subscriptionMainTree = this.sharedService.readPortal('mydestinasi','', '','',lang).subscribe(
    data => {
      
      this.listName = data['list'];
      this.listMainTree = data['list'];
      this.rangeDistance = [data['minRadius'] * 1000, data['maxRadius'] * 1000];
      console.log("this.rangeDistance : ",this.rangeDistance);
      console.log("########### Main Tree Original ###########: ", this.listMainTree);

      //====================asal getLoopTree========================

      // // PART A: call all api from all agency
      // for (let i = 0; i < this.listMainTree.length; i++){
      //   // if(i == 0){
      //   //   this.getLoopTree('https://theazazil.com/bombaNew/apisvc.php/'+'getCategoryList');
      //   // }
      //   // else{
      //     this.getLoopTree(this.listMainTree[i].value.sourceUrl+'getCategoryList');
      //   // }
        
      // } 

      //====================end asal getLoopTree========================

      this.getLoopTree2(0, this.listMainTree.length, this.listMainTree);

      //====================asal getLoopTree========================

      // clearTimeout(this.typingTimer);
      // this.typingTimer = setTimeout(()=>{

      //   for (let i = 0; i < this.allTree.length; i++){
      //     this.allTree[i].value['openFlag2nd'] = false;
      //     this.allTree[i].value['sourceUrl'] = this.listMainTree[i].value.sourceUrl;
      //     this.allTree[i].value['code'] = this.listMainTree[i].value.code;
      //     this.allTree[i]['text'] = this.listMainTree[i].text; // take from mydestinasi append to agency api
      //   } 

      //   console.log("################### NEW TREE ##################: ", this.allTree);
      //   this.listMainTree = this.allTree;

      // }, this.doneTypingInterval);
      // // end PART A

      //====================end asal getLoopTree========================

      //if parent default openFlag2nd = true and need to close A
      // for (let i = 0; i < this.listMainTree.length; i++){
      //   this.getExpandTree(this.listMainTree[i].value.code, this.listMainTree[i].value.sourceUrl, i);
      // } 

    },
    error => {
      this.loading = false;
    });    
  }

  getLoopTree(paramURL){ 
    this.loading = true; 

    this.sharedService.getListDestination(paramURL+"?language="+this.langID,'', '','').subscribe(
    data => {
      let a = data['data'];
      if( a == undefined){
        this.allTree.push(data);
      }else{
        this.allTree.push(data["data"][0]);
      }     
      
      this.loading = false; 
    },
    error => {
      this.loading = false;
    });
  }

  getLoopTree2(step, lengthList, treeMain){ 
    let paramURL = '';
    console.log("STEP : ",step);
    console.log("LENGTHLIST : ",lengthList);
    console.log("treeMain : ",treeMain);
    // if(step == 0){
    //   paramURL = 'https://theazazil.com/bombaNew/apisvc.php/getCategoryList';
    // }
    // else if (step != 0){
    //   paramURL = treeMain[step].value.sourceUrl+'getCategoryList';
    // }

    paramURL = treeMain[step].value.sourceUrl+'getCategoryList';

    this.loading = true; 

    this.subscriptionLoopTree2 = this.sharedService.getListDestination(paramURL+"?language="+this.langID,'', '','').subscribe(
    data => {
      let a = data['data'];
     
      if( a == undefined){ // Bomba Format
        this.allTree.push(data);
      }else{

        console.log(data['data'].length);
        if(data['data'].length == undefined){ // Jakim Format
          this.allTree.push(data["data"]);
        }
        else{ // SI Card Format
          this.allTree.push(data["data"][0]);
        }
        // this.allTree.push(data["data"][0]);
      }    
      
      console.log("INI TREE: ",this.allTree);
      if(step+1 < lengthList){
        console.log("PANGGIL SEMULA : ");
        this.getLoopTree2(step+1, lengthList, treeMain);
      }

      else{
        console.log("LAST PANGGIL ");
        for (let i = 0; i < this.allTree.length; i++){

          // if(i == 0){
          //   this.allTree[i].value['openFlag2nd'] = false;
          //   this.allTree[i].value['sourceUrl'] = 'https://theazazil.com/bombaNew/apisvc.php/';
          //   this.allTree[i].value['code'] = this.listMainTree[i].value.code;
          //   this.allTree[i]['text'] = this.listMainTree[i].text; // take from mydestinasi append to agency api
          // }
          // else{
          //   this.allTree[i].value['openFlag2nd'] = false;
          //   this.allTree[i].value['sourceUrl'] = this.listMainTree[i].value.sourceUrl;
          //   this.allTree[i].value['code'] = this.listMainTree[i].value.code;
          //   this.allTree[i]['text'] = this.listMainTree[i].text; // take from mydestinasi append to agency api
          // }

          this.allTree[i].value['openFlag2nd'] = false;
          this.allTree[i].value['sourceUrl'] = this.listMainTree[i].value.sourceUrl;
          this.allTree[i].value['code'] = this.listMainTree[i].value.code;
          this.allTree[i]['text'] = this.listMainTree[i].text; // take from mydestinasi append to agency api
        } 

        console.log("################### NEW TREE ##################: ", this.allTree);
        this.listMainTree = this.allTree;
      }
      
      this.loading = false; 
    },
    error => {
      console.log("ERROR LOOP 2: ",error);
      //IF could not connect to agency server
      if(!error){
        this.allTree.push(treeMain[step]);
        if(step+1 < lengthList){
          console.log("PANGGIL SEMULA : ");
          this.getLoopTree2(step+1, lengthList, treeMain);
        }
      }
      this.loading = false;
    });
  }

  getExpandTree(code, sourceCode, idx, flag?){

    this.flagErrorConnect = false;
    //index of mainTree    
    let idxTree = this.listMainTree[idx]["children"];
    console.log("idxTree: ", idxTree);    
    this.loading = true;
    
    if(!idxTree){
      console.log("=======YOU EXPAND TREE =========: ",this.listMainTree);

      this.subscriptionExpandTree = this.sharedService.getListDestination(sourceCode+"getCategoryList?language="+this.langID,'', '','').subscribe(
      data => {

        let a = data['data'].length;

        if(a == 1){ // real data
          this.listMainTree[idx]["children"] = data['data'][0].children;
        }else{ //dummy data
          this.listMainTree[idx]["children"] = data['data'].children;
        }

        // this.loading = false;
      },
      error => {
        this.flagErrorConnect = true;
        this.errAgencyConnect();
        console.log(error);
        // this.loading = false;
      });  
    }

    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(()=>{    

      this.listMainTree[idx].value['openFlag2nd'] = flag;
      console.log("Percubaan Flag: ",flag);
      if(flag){
        let y = document.getElementsByClassName(idx);  
        $(y).css('display','block');
        console.log(y);
        if(this.flagErrorConnect == false){ // bile error connection tiada.
          this.errState();
        }
        console.log("KELUAR ERROR STATE");
      }
      else{
        let y = document.getElementsByClassName(idx);  
        $(y).css('display','none');
        console.log("TIADA ERROR STATE");
      }

      console.log("this.flagErrorConnect : ", this.flagErrorConnect);
      this.loading = false;
    }, 500);
  }

  getPlaceInfoAll(page?, limitPage?, paramURL?, param?, parentC?){

    this.flagErrorConnect = false;
    this.loading = true;       
    
    this.subscriptionListPoint = this.sharedService.getListPoint(paramURL+"?language="+this.langID,'', '',param).subscribe(
    data => {

      let dataCurrPlace = data;
      let recordCurrPlace = dataCurrPlace['data'];
      console.log("Data: recordCurrPlace: ", recordCurrPlace);
      console.log("parentC: ", parentC);

      // ***bile user click category dan keyword not empty. set record place kpd originalRecPlace
      if(this.mapForm.get('keyword').value){
        console.log("+++++++++KEYWORD ADA++=++++");
        this.recordPlace = this.oriRecPlace;
      }

      if(recordCurrPlace){

        this.objCategory[this.currCategory] = recordCurrPlace;      

        for (let i = 0; i < this.objCategory[this.currCategory].length; i++) {
          this.recordPlace.push(this.objCategory[this.currCategory][i]);
        }        

        let tempR = this.recordPlace.filter(function( obj ) {
          return obj.id_category.split('_')[0] === parentC;
        });

        this.objCatByAgency[parentC].data = tempR;
        console.log("tempR : ",tempR);

      } //end if

      this.oriRecPlace = this.recordPlace;
             
      console.log("*** DATA ON MAP (recordPlace) *** : ",this.recordPlace);
      console.log("*** objCategory : ",this.objCategory);
      
      if(this.mapForm.get('keyword').value){ 
        this.searchRecord(this.mapForm.get('keyword').value);
      }

      else if(this.recordPlace.length > 0){ 

        this.plotToMap();
        console.log("currTB : ", this.currTB);

        // ***If have only 1 agency.
        if(this.noTabAgency.length == 1){          
          // let firtTab = this.noTabAgency[0];
          this.currTB = this.noTabAgency[0];
          this.currTabRec = this.objCatByAgency[this.currTB].data;          
        }
        // ***If have more then 1 agency. Get clicked Tab which is currTB
        else if(this.noTabAgency.length > 1){
          if(!this.currTB){
            // let firtTab = this.noTabAgency[0];
            this.currTB = this.noTabAgency[0];
            this.currTabRec = this.objCatByAgency[this.currTB].data; 
          }else{
            this.currTabRec = this.objCatByAgency[this.currTB].data;
          }
        }

        console.log("*** FIRST TAB Agency *** : ",this.currTabRec);
        this.recPlaceTbl(0, this.limit, this.currTabRec);
      } 
      else{  
        console.log("********** NO DATA AVAILABLE ******************");

        if(this.currTabRec == undefined){
          this.currTabRec = [];
        }
              
        if(this.markerGroup){
          this.mymap.removeLayer(this.markerGroup);   
        }

        this.recPlaceTbl(0, 0, this.currTabRec);  
        this.setMapByScreen();
      }

      this.loading = false;     
    },
    error => {
      if(this.mapForm.get('jCarian').value == 2){
        this.errorMsg();
      }
      else{
        this.flagErrorConnect = true;
        this.errAgencyConnect();
      }
      this.errorConnection();
      if(this.markerGroup){
        this.mymap.removeLayer(this.markerGroup);   
      }
      this.loading = false;
    });
  }  

  plotToMap(){

    // var layerCC=[];
    // var hospital =  L.layerGroup(layerCC); //L.layerGroup([ee, ff]);
    this.loading = true;
    let colorPin = '';
    let lat = '';
    let long = '';
    let main = this;

    // this.setMapByScreen()
    
    if(this.markerGroup){
      this.mymap.removeLayer(this.markerGroup);   
    }
    
    // this.mcgLayerSupportGroup = L.markerClusterGroup.layerSupport(null);
    this.markerGroup = L.markerClusterGroup({ chunkedLoading: true});  
    let markerList = [];
    console.log("Check code");

    for (let i = 0; i <= this.recordPlace.length - 1; i++) {

      // colorPin = 'assets/marker/'+this.objIcon[this.recordPlace[i].id_category].category+'.png'; 
      colorPin = this.objIcon[this.recordPlace[i].id_category].icon;

      this.defaultIcon = L.icon({
        iconUrl: colorPin,
        shadowUrl: 'assets/marker-shadow.png',
        iconSize: [15, 24], // size of the icon 25, 41
        shadowSize: [20, 21], // size of the shadow 40, 41
        iconAnchor: [15/2, 24], // point of the icon which will correspond to marker's location [25/2, 41]
        shadowAnchor: [15/2, 24],  // the same for the shadow
        popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
      });
      
      lat = this.recordPlace[i].lat;
      long = this.recordPlace[i].long;

      // console.log("LAT: float ", i, "ini i", lat, " COnvert : ", parseFloat(this.malformedDataHandler(lat)));
      // console.log("LNG: float ", i, "ini i", long, " COnvert : ", parseFloat(this.malformedDataHandler(long)));

      if(parseFloat(this.malformedDataHandler(lat))!== 0 && parseFloat(this.malformedDataHandler(long)) !== 0){

        var marker = L.marker(L.latLng(parseFloat(this.malformedDataHandler(lat)), parseFloat(this.malformedDataHandler(long))), { icon: this.defaultIcon });
        marker.bindPopup(this.displayPopup(
          parseFloat(this.malformedDataHandler(lat)),
          parseFloat(this.malformedDataHandler(long)),
          this.recordPlace[i].name,
          this.recordPlace[i].address,
          this.recordPlace[i].no_tel,
          this.recordPlace[i].postcode,
          this.recordPlace[i].id_state,
          this.recordPlace[i].distance
        ));
        marker.on('popupopen', function(e) {
          console.log(this.getLatLng().lat);
          console.log(this.getLatLng().lng);

          var px = main.mymap.project(e.target._popup._latlng);
          console.log("PX: ",px);
          px.y -= e.target._popup._container.clientHeight/2;
          if($(window).width()>319 && $(window).width()<481){

            // let y = document.getElementsByClassName('leaflet-popup-content');
            // $(y).css('width','260px');

            // let x = document.getElementsByClassName('leaflet-popup');
            // $(x).css('left','-150px');
          }  
          else if ($(window).width()>481){ 
          }
          main.mymap.panTo(main.mymap.unproject(px),{animate: true});
        });

        // marker.on('drag', function() {
        //   main.mymap.updateDirection();
        // });
        markerList.push(marker);
        
        // MARKER ONLY: open this if not using cluster
        // this.markerGroup = marker;
        // this.mymap.addLayer(this.markerGroup);
        // END MARKER ONLY
      }  
      else{
        // console.log("This record hv problem: ", i, " Lat ", lat, " Lng: ",long);
      }
    }

    this.markerGroup.addLayers(markerList);
    this.mymap.addLayer(this.markerGroup);
    this.showDetails = true;
    this.loading = false;
  }

  removeCluster(codePar, recParent){
    console.log("CODE PARENT : ",codePar);
    console.log("recordParent : ", recParent);
    this.noTabAgency = Object.keys(this.objCatByAgency);

    delete this.objCategory[this.currCategory];
    let tempRecord = [];
    let oriTempRecord = [];

    for (let i = 0; i < this.recordPlace.length; i++) {
      if(this.recordPlace[i].id_category != this.currCategory){
        tempRecord.push(this.recordPlace[i]);
      }
    }

    for (let i = 0; i < this.oriRecPlace.length; i++) {
      if(this.oriRecPlace[i].id_category != this.currCategory){
        oriTempRecord.push(this.oriRecPlace[i]);
      }
    }

    // If agency have category > 1 . Remove unchecked category. Eg: B_25, B26
    if(recParent > 0){
      let a = this.objCatByAgency[codePar].data;    
      let tempObjRec = [];

      for (let i = 0; i < a.length; i++) {
        if(a[i].id_category != this.currCategory){
          tempObjRec.push(a[i]);
        }
      }

      this.objCatByAgency[codePar].data = tempObjRec;

      console.log(tempObjRec);
      console.log(this.objCatByAgency);
    }

    this.recordPlace = tempRecord;
    this.oriRecPlace = oriTempRecord;

    // ***jika ada satu agency sahaja
    if(this.noTabAgency.length == 1){
      // let firtTab = this.noTabAgency[0];
      this.currTB = this.noTabAgency[0];
      this.currTabRec = this.objCatByAgency[this.currTB].data;
    }
    else if(this.noTabAgency.length > 1){ // ***jika lebih dari satu agency
      if(this.currTB){
        this.currTabRec = this.objCatByAgency[this.currTB].data;
      }else{
        // let firtTab = this.noTabAgency[0];
        this.currTB = this.noTabAgency[0];
        this.currTabRec = this.objCatByAgency[this.currTB].data;
      }
    }
    else if(this.noTabAgency.length == 0){
      this.noOfR = undefined;
      this.currTB = undefined;
      this.mapForm.get('keyword').setValue(null);
      this.recordPlace = [];
      this.oriRecPlace = [];
      this.plotToMap();
    }

    if(this.mapForm.get('keyword').value){
      this.searchRecord(this.mapForm.get('keyword').value);
    }

    else if(this.noTabAgency.length != 0 && !this.mapForm.get('keyword').value){
      this.plotToMap();    
      this.recPlaceTbl(0, this.limit, this.currTabRec);
    }

    console.log("====== YOU REMOVE THIS CATEGORY =========== : ", this.currCategory);
    console.log("================== MAP RECORD ============= : ", this.recordPlace);
    console.log("============ ORIGINAL MAP RECORD ========== : ", this.oriRecPlace);
    console.log("== CURRENT OBJ CAT (objCategory) ========== : ", this.objCategory);
    console.log("== CURRENT OBJ CAT by Agency (objCatByAgency) === : ", this.objCatByAgency);
  }

  newAddr(a, p, s){
    let address = '';
    let newA = '';
    let posCode = ''

    address += (a) ? a+',': '';
    posCode += (p) ? p: '';

    let sName = '';
    let idS = s;
    let stateName = this.listState.filter(function(value){
      if(idS == value.stateCode){
        return value.stateName;
      }
    });

    if(stateName.length > 0){
      sName = stateName[0].stateName;
    }
    
    newA = address +  " " + posCode + " " + sName;
    return newA;
  }

  recPlaceTbl(pg?, valLimit?, recCurrT?){

    this.totalPageNo = Math.ceil(recCurrT.length/this.limit);
    this.recordPlaceTbl = [];
    this.pageNo = 1; 
    let currPg = 0;
    let noLimit = 0;    

    if(pg){
      this.pageNo = pg;
      currPg = (pg * valLimit) - valLimit;
    }
    
    noLimit = valLimit * this.pageNo;

    if(noLimit <= recCurrT.length){
      noLimit = noLimit;
    }
    else{
      noLimit = recCurrT.length;
    }

    for(let i = currPg; i < noLimit; i++){
      this.recordPlaceTbl.push(recCurrT[i]);
    }

    if(this.recordPlaceTbl.length == 0){
      this.showNoData = true;
      this.showDetails = true;
    }else{
      this.showNoData = false;
    }
    
    //bile xde keyword ambil jumlah record dari current Tab.
    if(!this.mapForm.get('keyword').value){
      this.originalRecord = recCurrT.length;
    }

    console.log("recCurrT : ", recCurrT.length);
    console.log("this.recordPlaceTbl.length : ", this.recordPlaceTbl.length);
    console.log("no limit : ", noLimit);
    console.log("total page no. : ", this.totalPageNo);
  }

  searchRecord(valKey){

    console.log(valKey);
    
    let a;
    this.mymap.closePopup(); 
    
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(()=>{      

      if(valKey.length >= 3 || valKey.length == 0){

        let searchKeyMap = this.oriRecPlace;
        searchKeyMap = searchKeyMap.filter(function( obj ) {

          let condF;
          let condFName;
          if(obj.name){
            condFName = obj.name.toLowerCase().includes(valKey.toLowerCase());
          }
          else{
            condFName = "";
          }

          if(obj.address){
            condF = obj.address.toLowerCase().includes(valKey.toLowerCase());
          }
          else{
            condF = '';
          }

          return (            
            condFName ||
            condF
          );

        });
        this.recordPlace = searchKeyMap;
        console.log("KEY MAP: ", this.recordPlace);
        this.plotToMap();

        // ================= record in Tab ======================
        console.log("currTB in seacrch: ", this.currTB);
        if(this.noTabAgency.length == 1){          
          // let firtTab = this.noTabAgency[0];
          this.currTB = this.noTabAgency[0];          
          a = this.objCatByAgency[this.currTB].data;          
        }
        else if(this.noTabAgency.length > 1){
          if(!this.currTB){
            // let firtTab = this.noTabAgency[0];
            this.currTB = this.noTabAgency[0];
            a = this.objCatByAgency[this.currTB].data; 
          }else{
            a = this.objCatByAgency[this.currTB].data;
          }
        }
        this.originalRecord = a.length;
        console.log(a);
        console.log("ORIGINAL REC: ", this.originalRecord);

        if(a.length > 0){       
          a = a.filter(function( obj ) {
            let condFbyC;
            let condFbyPostcode;
            let condFbyName;

            if(obj.name){
              condFbyName = obj.name.toLowerCase().includes(valKey.toLowerCase());
            }
            else{
              condFbyName = "";
            }

            if(obj.address){
              condFbyC = obj.address.toLowerCase().includes(valKey.toLowerCase());
            }
            else{
              condFbyC = "";
            }

            if(obj.postcode){
              condFbyPostcode = obj.postcode.includes(valKey);
            }
            else{
              condFbyPostcode = "";
            }

            return (
              condFbyName ||
              condFbyC ||
              condFbyPostcode
            );
          });  
          this.currTabRec = a;
        }

        this.noOfR = a.length;
        this.recPlaceTbl(0, this.limit, this.currTabRec);
        
      } // end if valKey.length >= 3
      
      if(valKey.length == 0){
        this.noOfR = undefined;
      }

      console.log("SEARCH obj by Agency: ", this.objCatByAgency);
    }, this.doneTypingInterval);
    
  }

  searchMultipleCat(step, lengthAgency){

    this.flagErrorConnect = false;
    console.log("All cate: ",this.objCategory);
    let arrAgency = Object.keys(this.objCatByAgency);
    let agency = arrAgency[step];
    let urlParent = this.objCatByAgency[agency].url;
    let paramURL = '';
    let param;

    let allCategory = Object.keys(this.objCategory);
    let tempCate = allCategory.filter(function( obj ) {
      return obj.split('_')[0] === agency;
    });


    if(this.mapForm.get('jCarian').value == 1){
      paramURL = urlParent+'getPlaceInfo';

      param = { "state" : parseInt(this.mapForm.get('allState').value),
              "category": tempCate,
               "keyword": null};
    }
    else if(this.mapForm.get('jCarian').value == 2){
      paramURL = urlParent+'getPlaceInfoByRadius';

      param = { "lat" : this.mapForm.get('latitude').value,
               "long" : this.mapForm.get('longitude').value,
           "distance" : this.mapForm.get('distance').value,
            "category": tempCate,
             "keyword": null};
    }    

    console.log("SEARCH ALL Category : ",Object.keys(this.objCatByAgency));
    console.log(this.objCatByAgency);
    console.log(agency);
    console.log(paramURL);
    console.log("INI PARAM : ",param);    
    this.loading = true;
    this.sharedService.getListPoint(paramURL+"?language="+this.langID,'', '',param).subscribe(
    data => {
      let dataCurrPlace = data;
      let recordCurrPlace = dataCurrPlace['data'];
      console.log("INI RECORD MULTIPLE : ",recordCurrPlace);

      for (let i = 0; i < recordCurrPlace.length; i++) {
        this.oriRecPlace.push(recordCurrPlace[i]);
      }  

      this.recordPlace = this.oriRecPlace;

      // ***set semula objCategory;
      for(let i = 0; i < tempCate.length; i++){
        this.objCategory[tempCate[i]] = this.recordPlace.filter(function( obj ) {
          return obj.id_category === tempCate[i];
        });
      }

      this.objCatByAgency[agency].data = this.recordPlace.filter(function( obj ) {
        return obj.id_category.split('_')[0] === agency;
      });

      console.log("this.objCategory: ", this.objCategory);
      console.log("this.objCatByAgency : ",this.objCatByAgency);

      if(this.mapForm.get('keyword').value){ 
        this.recordPlace = this.oriRecPlace;
        this.searchRecord(this.mapForm.get('keyword').value);
      }

      else if(this.recordPlace.length > 0){ 

        this.plotToMap();
        console.log("currTB : ", this.currTB);

        // ***If have only 1 agency.
        if(this.noTabAgency.length == 1){          
          // let firtTab = this.noTabAgency[0];
          this.currTB = this.noTabAgency[0];
          this.currTabRec = this.objCatByAgency[this.currTB].data;          
        }
        // ***If have more then 1 agency. Get clicked Tab which is currTB
        else if(this.noTabAgency.length > 1){
          if(!this.currTB){
            // let firtTab = this.noTabAgency[0];
            this.currTB = this.noTabAgency[0];
            this.currTabRec = this.objCatByAgency[this.currTB].data; 
          }else{
            this.currTabRec = this.objCatByAgency[this.currTB].data;
          }
        }

        console.log("********** FIRST TAB Agency ******************* : ",this.currTabRec);
        this.recPlaceTbl(0, this.limit, this.currTabRec);
      } 
      else{  
        console.log("********** NO DATA AVAILABLE ******************");

        // if(this.currTabRec == undefined){
        //   this.currTabRec = [];
        // }
        this.currTabRec = [];      
        if(this.markerGroup){
          this.mymap.removeLayer(this.markerGroup);   
        }

        this.recPlaceTbl(0, 0, this.currTabRec);  
        this.setMapByScreen();
      }
      
    },
    error => {
      if(this.mapForm.get('jCarian').value == 2){
        this.errorMsg();
      }
      else{
        this.flagErrorConnect = true;
        this.errAgencyConnect();
      }
      this.loading = false;
    });

    if(step+1 < lengthAgency){
      console.log("PANGGIL SEMULA : ");
      this.searchMultipleCat(step+1, lengthAgency);
    }
    this.loading = false;
  }

  latLongNaN(lat, long){
    let tData;
    
    if(isNaN(parseFloat(lat)) || isNaN(parseFloat(long)))
      tData = "Nan";
    else
      tData = "good";

    return tData    
  }

  latLongNull(lat, long){
    let tData;
    
    if(!lat || !long)
      tData = "0.0";
    else
      tData = "good";
    return tData    
  }

  clickTab(e){
    if(this.noTabAgency.length > 0){
      this.currTB = this.noTabAgency[e.index];
    }
    
    if(e.index != -1 && this.noOfR == undefined){
      this.currTabRec = this.objCatByAgency[this.currTB].data;
    }  

    if(this.noOfR != undefined){
      this.searchRecord(this.mapForm.get('keyword').value);
    }

    this.recPlaceTbl(0, this.limit, this.currTabRec);
  }

  nameTab(index){
    let nameT = '';

    for(let i = 0; i < this.listName.length; i++) {

      if(this.listName[i].value.code == index){
        nameT = this.listName[i].text;
      }
    }
    return nameT;
  }
  
  getDefaultMap() {

    if($(window).width()>319 && $(window).width()<481){
      this.mymap = L.map('dirmap').setView([4.7502151,108.662241], 4); // for overlay
    }  
    else if ($(window).width()>481){
      this.mymap = L.map('dirmap').setView([4.9502151,102.662241], 5); // for overlay
    }

    // this.mymap = L.map('dirmap').setView([4.9502151,102.662241], 5); // for overlay
    // this.mymap = L.map('dirmap').setView([4.2055334,115.8897801], 5); // for push (off-canvas)

    // this.mymap = L.map('dirmap').setView([4.5998733,112.1983739], 6);
    // this.mymap = L.map('dirmap').setView([4.8142568, 108.5806004], 6); asal school
    // L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', { // lama mapbox
    L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
    // L.tileLayer('//{s}.tile.osm.org/{z}/{x}/{y}.png', {
      attribution: '',
      maxZoom: 18,
      minZoom: 3,
      tileSize: 512,
      zoomOffset: -1,
      // id: 'osm.streets', 
      // id: 'mapbox.streets', // lama mapbox
      id: 'mapbox/streets-v11', 
      accessToken: 'pk.eyJ1IjoicmVkemEiLCJhIjoiY2pmcGZxNzRrMjYzbzMwcG83bGRxY2FtZyJ9.uMHQpYc0Pvjl4us27nHH8w'
      
    }).addTo(this.mymap);

    this.mymap.removeControl(this.mymap.zoomControl); // remove zoom on topleft
    L.control.zoom({
      position:'topright'
    }).addTo(this.mymap);

    let attribution = this.mymap.attributionControl;
    attribution.setPrefix(false);
  }

  locateUser() {
    console.log("Locate User Func()");
    this.completeLatLong = false;
    var main = this;
    var mymap = this.mymap;
    var mapForm = this.mapForm;

    this.defaultIcon = L.icon({
      iconUrl: 'assets/marker/marker-icon-yellow.png',
      shadowUrl: 'assets/marker-shadow.png',
      iconSize: [15, 24], // size of the icon 25, 41
      shadowSize: [20, 21], // size of the shadow 40, 41
      iconAnchor: [15/2, 24], // point of the icon which will correspond to marker's location
      shadowAnchor: [15/2, 24],  // the same for the shadow
      popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
    });

    
    this.mymap.locate({setView : true, maxZoom: 15})
    .on('locationfound', function(e){

      if(main.markerUser){
        mymap.removeLayer(main.markerUser);
        mymap.removeLayer(main.circleUser);
      }

      if(main.circleRad){
        mymap.removeLayer(main.circleRad);
      }

      // main.markerUser = L.marker([e.latlng.lat, e.latlng.lng], { icon: main.defaultIcon }).bindPopup((this.langID==1)?'Your location!':'Lokasi anda!');
      main.markerUser = L.marker([e.latlng.lat, e.latlng.lng], { icon: main.defaultIcon }).bindPopup(e.latitude+","+e.longitude);
      main.circleUser = L.circle([e.latlng.lat, e.latlng.lng], 100, {
          weight: 1,
          color: 'red',
          fillColor: 'red',
          fillOpacity: 0.5
      });
      mymap.addLayer(main.markerUser);
      mymap.addLayer(main.circleUser);

      if(mapForm.get('distance').value){
        let a = mapForm.get('distance').value;
        main.circleRad = L.circle([e.latlng.lat, e.latlng.lng], a, {
            weight: 1,
            color: '#61FF33',
            fillColor: '#61FF33',
            fillOpacity: 0.2
        });
        mymap.addLayer(main.circleRad);
      }

      mapForm.get('latitude').setValue(e.latitude);
      mapForm.get('longitude').setValue(e.longitude);   

      // let y = document.getElementsByClassName('leaflet-map-pane');
      // $(y).css('transform','translate3d(-150px, 0px, 0px)');
    })
    .on('locationerror', function(e){
      console.log("Location access denied.");
      main.errorMsg();
    });
    
    this.completeLatLong = true;
  }

  setMapByScreen(){
    if($(window).width()>319 && $(window).width()<481){
      this.mymap.setView([4.7502151,108.662241], 4); // for overlay
    }  
    else if ($(window).width()>481){
      this.mymap.setView([4.9502151,102.662241], 5); // for overlay
    }

    // this.mymap.setView([4.9502151,102.662241], 5); // for overlay
    // this.mymap.setView([4.2055334,115.8897801], 5); // for push (off-canvas)
  }

  // reset search form values
  resetSearch(reset?){
    
    if(this.markerGroup){
      this.mymap.removeLayer(this.markerGroup); 
      this.mymap.closePopup();
    } 
    if(this.markerUser){
      this.mymap.removeLayer(this.markerUser);
      this.mymap.removeLayer(this.circleUser);
    }
    if(this.circleRad){
      this.mymap.removeLayer(this.circleRad);
    }

    this.setMapByScreen();    
    this.mapForm.get('allState').reset();
    this.mapForm.get('latitude').reset();
    this.mapForm.get('longitude').reset();
    this.mapForm.get('distance').reset();
    this.mapForm.get('subKat').reset();
    this.mapForm.get('subKat2').reset();
    this.mapForm.get('keyword').reset();
    this.mapForm.get('subKat').disable();
    this.mapForm.get('subKat2').disable();  
    this.selectedCat = [];
    this.sameCategoryCodeLvl1 = [];
    this.recordPlaceTbl = [];
    this.recordPlace = [];
    this.noTabAgency = [];
    this.currTabRec = [];
    this.objCategory = {};
    this.objCatByAgency = {};
    this.objIcon = {};
    this.currTB = undefined;
    this.noOfR = undefined;

    this.pageNo = 1;
    this.totalPageNo = 1;
    this.limit = 15;

    if(this.mapForm.controls.jCarian.value == 2 && reset == 'reset'){//reset latlong complete.
      console.log("MASUK UNTUK RESET");
      this.completeLatLong = false;
      // this.changeJCarian(2, false);
      this.locateUser();  
      this.mapForm.get('subKat').enable();
      this.mapForm.get('subKat2').enable();
      
      this.mapForm.get('distance').setValue(this.rangeDistance[0]);
      this.minDisplay = this.rangeDistance[0] / 1000;
      this.maxDisplay = this.rangeDistance[1] / 1000;    

      this.currDistance = this.rangeDistance[0]/1000;
    }

    this.showDetails = false;
    this.checkReqValues(); // check to disable search btn
  }

  resetMethod() {
    this.resetSearch('reset');
  }

  errorConnection(){
    this.noOfR = undefined; 
    this.originalRecord = 0;
  }

  errorMsg(){
    if(this.langID==1){
      this.sharedService.showError('Your location could not be found. Please ensure your GPS is activated.', '');
    }else{
      this.sharedService.showError('Lokasi anda tidak dapat dijumpai. Sila pastikan GPS anda diaktifkan', '');
    }
  }

  // check value to enable button search
  checkReqValues() {

    let reqVal = [];
    let nullPointers:any = [];
    
    if(this.mapForm.controls.jCarian.value == 1){
      reqVal =  ["allState"];
    }
    else{
      reqVal =  ["distance"];
    }

    for (var reqData of reqVal) {
      let elem = this.mapForm.get(reqData);

      if (elem.value == "" || elem.value == null) {
        elem.setValue(null)
        nullPointers.push(null)
      }
    }

    if(nullPointers.length > 0) {
      
      this.complete = false;
      
    } else {      
      this.complete = true;
    }
  }

  /** navigate to last page - right arrow */
  paginatorRL(page, val){
    // document.getElementById("mainTable").focus();
    $(window).scrollTop(500);
    this.recPlaceTbl(page, val, this.currTabRec);
    this.loading = false;
  }

  /** navigate to next list - right arrow */
  paginatorR(page, val){
    $(window).scrollTop(500);
    // document.getElementById("mainTable").focus();
    this.recPlaceTbl(page, val, this.currTabRec);
    this.loading = false;
  }

  /** navigate to prev list - left arrow  */
  paginatorL(page, val){
    $(window).scrollTop(500);
    // document.getElementById("mainTable").focus();
    this.recPlaceTbl(page, val, this.currTabRec);
    this.loading = false;
  }

  /** navigate to first page - left arrow */
  paginatorL1(page, val){
    $(window).scrollTop(500);
    // document.getElementById("mainTable").focus();
    this.recPlaceTbl(0, val, this.currTabRec);    
    this.loading = false;
  }

  pageChange(event){
    $(window).scrollTop();
    // $(document).scrollTop();
    // document.body.scrollTop = 0;
    // $("#mainTable").animate({ scrollTop: 0 }, 1000);
    // document.getElementById("mainTable").focus();
    this.limit = event.value;
    this.recordPlaceTbl = [];

    this.recPlaceTbl(0, this.limit, this.currTabRec);
    // let position = $('#boxHasil').position();
 
    // if(position){      
    //   $('.container').scrollTop(position.top);
    // }  
  }

  validNameSc(e){
    let a = '';
    a = this.mapForm.controls.keyword.value;
    if(a){

      if(a.trim().length >= 3){
        this.validNS = false;
      }else{
        this.validNS = true;
      }

      var k = e.keyCode;
      if(k == 13 && a.trim().length >= 3){
        this.popup.remove();
        this.mapForm.get('keyword').setValue('');
        this.showDetails = true;

        this.noOfR = undefined;
      }
    }

    else{
      this.validNS = true;
    }
  }

  /** function to prevent special characters in input field - used in (keypress) */
  preventSpecialChar(e){   
    var k = e.charCode;
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)); 
  }
  
  malformedDataHandler(data) {
    let tData;

    // if (!data || data === 'undefined' || data == "")
    //   tData = "0.0"
    if(isNaN(data) || !data)
      tData = "0.0"
    else
      tData = data;

    return tData
  }
  
  getThemeF() {
    return localStorage.getItem('themeColor');
  }

  // view detail modal
  view(val, type){     
    
    let selectedData = val;
    let sName = '';
    let a = val.id_state;
    let state = this.listState.filter(function(value){
      // if(val.id_state == value.stateId){//asal
      if(a == value.stateCode){ //Temporary only. BE need to send id_state from MIMOS not from agency
        return value.stateName;
      }
    });
    let workH = val.operation[0];

    if(state.length > 0){
      sName = state[0].stateName;
    }

    console.log("Popup : ",val);
    console.log(this.listState);
    console.log("INI STATE: ", sName);
    
    let fullAddress = '';
    let address = '';
    address += (val.address) ? val.address+',': '';
    let pCode = '';
    pCode += (val.postcode) ? val.postcode: '';
    fullAddress += address + " " + pCode + " " + sName;

    console.log("Full Add: ",fullAddress);

    this.dialog.open(MydestinasiPopupDialog, {
      data: {
        recInfo: val,
        typeData: type,
        // stateName: val.id_state,
        stateName: sName,
        workingH: workH,
        fullAdd: fullAddress
      }
    });
  }
}

@Component({
  selector: 'mydestinasi-addinfo',
  templateUrl: './mydestinasi-addinfo.html',
  styleUrls: ['./mydestinasi-addinfo.css']
})

export class MydestinasiPopupDialog {

  flagPrint: any;
  constructor(
    public dialogRef: MatDialogRef<MydestinasiPopupDialog>,
    private translate: TranslateService,
    private router: Router,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

    ngOnInit(){

      if(this.data.typeData == 1){
        this.dialogRef.updatePosition({ top: '0'});
      }
    }

    onNoClick() {
      this.dialogRef.close();
    }

    clickUrl2(urlsc){

      let a = '';
      let res = '';
  
      a = urlsc.substring(0, 3);
  
      if(a.toLowerCase() == 'htt'){
        res = urlsc;
      }
  
      else{
        res = 'http://'+urlsc;
      }
  
      // if(a.toLowerCase() == 'www'){
      //   res = 'http://'+urlsc;
      // }
  
      return res;
    }
    
    onPrint(){
      window.print();
    }
}


// WEBPACK FOOTER //
// ./src/app/mydestinasi/mydestinasi.component.ts